import { indexSessionStatus } from "../../../api/endpoints/learner/waiting";
import LearnerCandidateReadingRoom from "../../../components/sessions/LearnerCandidateReadingRoom";

export default function ReadingRoomNewBoarding() {
  return <LearnerCandidateReadingRoom getUserSession={indexSessionStatus} />;
}
